import StatisticsPage from "./index.vue";

export default [
  {
    path: "/statistics",
    name: "statistics",
    displayName: "routes.statistics",
    icon: "mdi-chart-areaspline",
    component: StatisticsPage,
    roles: ["admin", "restaurant", "report", "company"],
  },
];
